// extracted by mini-css-extract-plugin
module.exports = {"customNavTab":"AlertDetailsNavTabs_customNavTab__2X577","alertCardsCol":"AlertDetailsNavTabs_alertCardsCol__7BhZY"};